export const PASSWORD_REQUIREMENTS = [
  { id: 'length', label: 'At least 8 characters', test: (pwd) => typeof pwd === 'string' && pwd.length >= 8 },
  { id: 'lowercase', label: 'At least one lowercase letter', test: (pwd) => /[a-z]/.test(pwd || '') },
  { id: 'uppercase', label: 'At least one uppercase letter', test: (pwd) => /[A-Z]/.test(pwd || '') },
  { id: 'number', label: 'At least one number', test: (pwd) => /\d/.test(pwd || '') },
  { id: 'symbol', label: 'At least one symbol', test: (pwd) => /[^A-Za-z0-9]/.test(pwd || '') }
];

function getStrengthLabel(score) {
  switch (score) {
    case 0:
      return 'Enter a password to see the strength.';
    case 1:
    case 2:
      return 'Weak password.';
    case 3:
      return 'Moderate password.';
    case 4:
      return 'Good password.';
    default:
      return 'Strong password.';
  }
}

function getStrengthVariant(score) {
  if (score <= 1) return 'danger';
  if (score <= 3) return 'warning';
  return 'success';
}

export function evaluatePasswordStrength(password) {
  const statuses = PASSWORD_REQUIREMENTS.map((rule) => ({
    id: rule.id,
    label: rule.label,
    met: Boolean(rule.test(password))
  }));

  const score = statuses.filter((req) => req.met).length;
  const maxScore = PASSWORD_REQUIREMENTS.length;
  const percent = Math.round((score / maxScore) * 100) || 0;

  return {
    statuses,
    score,
    maxScore,
    percent,
    isStrong: score === maxScore,
    label: getStrengthLabel(score),
    variant: getStrengthVariant(score)
  };
}
